import { Dispatch, FC, SetStateAction, useEffect } from "react";
import SearchTable from "../../../components/template/Search/SearchTable";
import { TableConfig } from "../../../types/Components/Table/TableConfig";
import { PaginationConfig } from "../../../types/Components/Table/PaginationConfig";
import { AuthUser } from "../../../types/User/AuthUser";
import ModalAlertSan from "../components/ModalAlertSan";
import { ModalConfig } from "../../../types/Components/Modal/ModalConfig";

interface IndicatorAlertSanProps {
  user: AuthUser;
  setIsSearching: Dispatch<SetStateAction<boolean>>;
  paginationConfig: PaginationConfig;
  setIdItem: Dispatch<SetStateAction<number>>;
  idItem: number;
  tableConfig: TableConfig;
  modalConfig: ModalConfig;
  control: any;
  setValue: any;
  watch: any;
  handleSubmit: any;
  reset: any;
  errors: any;
}

const IndicatorAlertSan: FC<IndicatorAlertSanProps> = ({
  user,
  setIsSearching,
  paginationConfig,
  setIdItem,
  idItem,
  tableConfig,
  modalConfig,
  control,
  setValue,
  watch,
  handleSubmit,
  reset,
  errors,
}) => {
  const handleAddNewItem = () => {
    modalConfig.openModal("Criar Alerta SAN", "Criar Alerta SAN");
    reset({
      name: "",
      rationalDescription: "",
      impactDescription: "",
      frequencyOption: null,
      indicators: [],
    });
    setIdItem(0);
  };

  useEffect(() => {
    if (!modalConfig.isOpen) {
      reset({
        name: "",
        rationalDescription: "",
        impactDescription: "",
        frequencyOption: null,
        indicators: [],
      });
      setIdItem(0);
      setIsSearching(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalConfig.isOpen, reset]);

  return (
    <SearchTable
      handleAddNewItem={
        user && user?.permissions?.includes("CreateAlertSan")
          ? handleAddNewItem
          : null
      }
      showModal
      createButtonName="Criar Alerta SAN"
      searchTableName=""
      headingFontSize="2xl"
      tableConfig={tableConfig}
      paginationConfig={paginationConfig}
    >
      <ModalAlertSan
        control={control}
        errors={errors}
        handleSubmit={handleSubmit}
        idItem={idItem ? idItem : 0}
        modalConfig={modalConfig}
        watch={watch}
        user={user}
      />
    </SearchTable>
  );
};

export default IndicatorAlertSan;
